import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { Badge } from "../Badge/Badge.js";
/* empty css                      */
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/UploadStatusBadge/UploadStatusBadge.tsx
var TONES = {
	completed: "success",
	processing: "warning",
	queued: "neutral",
	rejected: "danger"
};
var LABELS = {
	completed: "Completed",
	processing: "Processing",
	queued: "Queued",
	rejected: "Rejected"
};
/**
* An upload's status as a subtle badge with a dot: Completed (success), Processing
* (warning, with a spinner in place of the dot), Queued (neutral) and Rejected (danger,
* a button that opens the error report).
*/
function UploadStatusBadge({ status, onRejectedClick, rejectedActionLabel = "Rejected, view error report", label = LABELS[status], size = "md", live = false, className }) {
	const processing = status === "processing";
	const common = {
		tone: TONES[status],
		size,
		dot: !processing,
		className: cx("ds-upload-status", `ds-upload-status--${status}`, className)
	};
	const content = /* @__PURE__ */ jsxs(Fragment, { children: [processing && /* @__PURE__ */ jsx("span", {
		className: "ds-upload-status__spinner",
		"aria-hidden": "true",
		children: /* @__PURE__ */ jsx(Icon, { name: "loader" })
	}), label] });
	const badge = status === "rejected" && onRejectedClick ? /* @__PURE__ */ jsx(Badge, {
		...common,
		onClick: onRejectedClick,
		"aria-label": rejectedActionLabel,
		children: content
	}) : /* @__PURE__ */ jsx(Badge, {
		...common,
		children: content
	});
	if (!live) return badge;
	return /* @__PURE__ */ jsx("span", {
		role: "status",
		className: "ds-upload-status__live",
		children: badge
	});
}
//#endregion
export { UploadStatusBadge };

//# sourceMappingURL=UploadStatusBadge.js.map